import { BasePool } from 'core/components/reels/symbols/base/BasePool'
import { ReelSymbol } from 'core/components/reels/symbols/base/ReelSymbol'
import Container from 'core/display/Container'
import { gsap, Power1 } from 'gsap'
import { signal } from 'services/SignalsService'
import { reelsSettings, volcanoReelSetting } from 'settings/custom/reels'

export default class SlideReel extends Container {
  constructor(data) {
    super()
    this._data = data
    this.id = parseFloat(data.name.match(/\d+/))
    this.symbolPool = new BasePool()
    this.itemCount = reelsSettings.itemCount[this.id]
    this.reelItems = []

    this.createSignal()
  }

  get data() {
    return this._data
  }

  createSignal() {
    signal.once('STATE:OUT:INIT', this.initReel.bind(this))
  }

  initReel(){
    for (let i = 0; i < this.itemCount; i++) {
      const item = new ReelSymbol(this.symbolPool)
      const itemHeight = game.models.ItemsModel.height
      this.reelItems.push(item)
      item.y = i * itemHeight
      this.addChild(item)
      const symbol = game.models.SpinModel.get().matrix[this.id][i]
      item.setSymbol(symbol)
      game.models.SpinModel.setSlideSymbol(this.id, i, item)
    }
  }

  async start(texture) {
    await this.slide(texture)
    signal.dispatch('END-STOP-REEL', this.id)

  }

  refresh() {
    for (let i = 0; i < this.itemCount; i++) {
      const symbol = game.models.SpinModel.get().matrix[this.id][i]
      this.reelItems[i].setSymbol(symbol)
      game.models.SpinModel.setSlideSymbol(this.id, i, this.reelItems[i])
    }
  }

  async slide(texture) {
    const self = this

    return new Promise((resolve) => {
      signal.dispatch('BEGIN-STOP-REEL', this.id)
      return new Promise((resolveAnim) => {
        gsap.fromTo(texture, { x: self.data.x, y: -1200 }, {
          y: 1100,
          duration: volcanoReelSetting[game.models.ModeModel.turbo].magmaDelay,
          ease: Power1.easeIn,
          onStart: () => {
            gsap.delayedCall(volcanoReelSetting[game.models.ModeModel.turbo].itemReelsDelay, () => {
              for (let i = 0; i < self.itemCount; i++) {
                gsap.delayedCall((volcanoReelSetting[game.models.ModeModel.turbo].itemMagmaDelay * i), () => {
                  const symbol = game.models.SpinModel.get().matrix[self.id][i]
                  self.reelItems[i].setSymbol(symbol)
                  game.models.SpinModel.setSlideSymbol(self.id, i, self.reelItems[i])
                })
              }
            })
          },
          onComplete: resolveAnim,
        })
      }).then(resolve)
    })
  }
}
